export const FIRST_NAME_INVALID_CHARACTERS_EXPRESSION = /([^a-zA-Z0-9\'\.\-])+/g;
export const LAST_NAME_INVALID_CHARACTERS_EXPRESSION = /([^a-zA-Z0-9\'\.\-\s])+/g;
